// Module
var code = "<div ng-class=\"$ctrl.classObj\" compile-element=\"$ctrl.messageBody.$$unwrapTrustedValue()\"></div> ";
// Exports
module.exports = code;